import { render } from "./shopOfferPost.vue?vue&type=template&id=5ea5ff52&scoped=true"
import script from "./shopOfferPost.vue?vue&type=script&lang=js"
export * from "./shopOfferPost.vue?vue&type=script&lang=js"

import "./shopOfferPost.vue?vue&type=style&index=0&id=5ea5ff52&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ea5ff52"

export default script